export function domReady(callback: () => void) {
    if ((document as any).attachEvent
        ? document.readyState === "complete"
        : document.readyState !== "loading") {
        callback();
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
}
